import { isEmpty } from "@/utils/isEmpty";
import classNames from "classnames";
import { useCallback, useMemo } from "react";
import HBIcon from "../../../HBIcon";
import Image from "../../../Image";
import styles from "./index.module.less";
export const STATUS = {
  NEW: 0,
  UPLOADING: 1,
  FAILURE: 2,
  DONE: 3,
};

const ShortErrMap = {
  "该图片你已经采集超过5次，无法完成采集，换一张试试吧": "采集多次",
  "花瓣系统检测到该图片内容可能违规，不能采集到你的画板，换一张试试吧。":
    "图片违规",
};

export default function ImageAvatar({
  progress,
  coverUrl,
  selected,
  status,
  onClose,
  onReUpload,
  onSelect,
  className,
  needCheckPromot,
  resources = {},
}) {
  const onClick = useCallback(() => {
    !selected && onSelect && onSelect();
  }, [onSelect, selected]);
  // 是否展示校验提示
  const needPerfect = useMemo(() => {
    // 需要检查promot，且promot不存在
    if (
      status === STATUS.DONE &&
      needCheckPromot &&
      isEmpty(resources.ossFile?.aigc?.prompt)
    ) {
      return true;
    } else {
      return false;
    }
  }, [needCheckPromot, resources, status]);

  return (
    <div
      className={classNames(className, styles.imageAvatar, {
        [styles.selected]: selected,
        [styles.uploading]: status === STATUS.UPLOADING,
      })}
      onClick={onClick}
    >
      <div className={styles.selectedBoard}>
        <div className={styles.imgWrapper}>
          {coverUrl ? (
            <Image
              className="transparent-img-bg"
              src={coverUrl}
              width={84}
              height={84}
              alt="图片"
            />
          ) : (
            <div style={{ width: 84, height: 84, background: "pink" }} />
          )}

          {status === STATUS.DONE && (
            <div className={styles.closeBtn} onClick={onClose}>
              <HBIcon type="ic_clear2" />
            </div>
          )}

          <div
            className={classNames(styles.cover, {
              [styles.show]: status !== STATUS.DONE || needPerfect,
            })}
          >
            {status === STATUS.UPLOADING && (
              <div className={styles.progressContainer}>
                <div
                  className={styles.progress}
                  style={{ width: `${progress}%` }}
                />
              </div>
            )}
            {status === STATUS.DONE && needPerfect && (
              <div className={styles.errorTip}>完善信息</div>
            )}
            {status === STATUS.FAILURE && (
              <div className={styles.errorTip}>
                <span className={styles.tipSign}>
                  <HBIcon className={styles.icon} type="ic_alert" />
                  {resources.failMsg && (
                    <div className={styles.failMsg}>
                      {ShortErrMap[resources.failMsg] || "上传失败"}
                    </div>
                  )}
                </span>
                <div className={styles.errorActions}>
                  {!resources.failMsg && (
                    <div className={styles.reuploadBtn} onClick={onReUpload}>
                      重新上传
                    </div>
                  )}
                  <div className={styles.closeBtn} onClick={onClose}>
                    <HBIcon type="ic_clear2" />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
